import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {Dropdown} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {DropdownList} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {
  CalendarReminderUnitsEnum,
  calendarReminderUnitToText,
} from '../../../helpers/calendarReminderHelpers';

/*
 * Props.
 */

export interface CalendarReminderUnitDropdownBoxProps {
  unit: CalendarReminderUnitsEnum;
  onChange: HandlerOf<CalendarReminderUnitsEnum>;
  className?: string;
}

/*
 * Component.
 */

export const CalendarReminderUnitDropdownBox: FC<CalendarReminderUnitDropdownBoxProps> = (props) => (
  <DropdownBoxCoordinator
    value={calendarReminderUnitToText[props.unit]}
    renderDropdown={(popoverProps) => renderUnitsDropdown(popoverProps, props)}
    boxClassName={props.className}
  />
);

function renderUnitsDropdown(
  popoverProps: PopoverTransferProps,
  props: CalendarReminderUnitDropdownBoxProps,
) {
  const units = [
    CalendarReminderUnitsEnum.MINUTE,
    CalendarReminderUnitsEnum.HOUR,
    CalendarReminderUnitsEnum.DAY,
    CalendarReminderUnitsEnum.WEEK,
  ];

  return (
    <Dropdown {...popoverProps}>
      <DropdownList {...popoverProps}>
        {units.map((unit) => {
          const isChecked = unit === props.unit;

          return (
            <DropdownItem key={unit} isChecked={isChecked} onSelect={() => props.onChange(unit)}>
              <DropdownItemContent isChecked={isChecked}>
                {calendarReminderUnitToText[unit]}
              </DropdownItemContent>
            </DropdownItem>
          );
        })}
      </DropdownList>
    </Dropdown>
  );
}
